import * as Zapi from '@zattoo/zapi';
export const zapiSessionHello = async (parameters) => {
    await Zapi.helloSessionV3({
        app_tid: parameters.appTid,
        app_version: parameters.appVersion,
        uuid: parameters.uuid,
    });
};
